"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _shallowequal = _interopRequireDefault(require("shallowequal"));
var _utils = require("./utils");
var _FormComponent = _interopRequireDefault(require("../FormComponent"));
var _excluded = ["className", "theme", "testId", "children", "onChange", "onSubmit"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** Components that should not be automatically paired with additional labels, likely because they roll their own labels */
var componentsNotNeedingLabels = ['Checkbox'];
var defaultProps = {
  theme: {},
  testId: '',
  onChange: function onChange() {},
  onSubmit: function onSubmit() {}
};

/**
 * Provides control over a set of input components and handles validation
 */
var Form = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Form, _React$PureComponent);
  function Form(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Form);
    _this = _callSuper(this, Form, [props]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentDidMount", function () {
      var shouldUpdateState = false;
      var promises = [];
      var fieldValues = _utils.FormUtils.getFieldsValues(_this.state.form.meta);

      // Run async validations on each field, if all sync validations are valid
      Object.keys(_this.formComponents).forEach(function (componentKey) {
        var component = _this.formComponents[componentKey];
        var fieldState = _this.state.form.meta[component.props.name];
        var validationResult = fieldState.validationResult;
        var pendingValidations = validationResult.pendingValidations || {};
        var fieldHasPendingValidations = Object.keys(pendingValidations).length > 0;
        var promise = validationResult.isValid && fieldHasPendingValidations ? _utils.FormValidator.asyncValidate(component, fieldState.value, fieldValues, validationResult) : Promise.resolve(validationResult);

        // Store validation result
        var wrappedPromise = promise.then(function (result) {
          return {
            key: component.props.name,
            validationResult: result
          };
        });

        // should update if at least one field has pending validations
        shouldUpdateState = shouldUpdateState || fieldHasPendingValidations;
        promises.push(wrappedPromise);
      });
      Promise.all(promises).then(function (results) {
        if (shouldUpdateState) {
          var newFormState = _objectSpread({}, _this.state.form);
          results.forEach(function (result) {
            return newFormState.meta[result.key].validationResult = result.validationResult;
          });
          newFormState.isValid = _utils.FormUtils.getIsFormValid(newFormState.meta);
          newFormState.isPending = _utils.FormUtils.getIsFormPending(newFormState.meta);
          _this.setState({
            form: newFormState
          });
        }
      });
    });
    // eslint-disable-next-line camelcase
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps === _this.props || !nextProps.value || (0, _typeof2["default"])(nextProps.value) !== 'object') {
        return;
      }

      // Update state if components have changed
      var newFormComponents = _utils.FormUtils.getFormComponents(nextProps.children);
      var formComponentsNames = Object.keys(_this.formComponents);
      var newFormComponentsNames = Object.keys(newFormComponents);

      // Check if there are new components or a component was removed
      var componentsHaveChanged = formComponentsNames.length !== newFormComponentsNames.length || Object.keys(newFormComponents).reduce(function (acc, key) {
        return acc || formComponentsNames.indexOf(key) === -1;
      }, false);
      if (componentsHaveChanged) {
        _this.formComponents = newFormComponents;
        _this.setState({
          form: _utils.FormUtils.getInitialFormState(_this.formComponents, nextProps.value)
        });
        return;
      }

      // Check if the same components have change any of their properties
      Object.keys(newFormComponents).forEach(function (key) {
        var component = _this.formComponents[key];
        var newComponent = newFormComponents[key];
        var componentHasChanged = !(0, _shallowequal["default"])(component.props, newComponent.props);
        componentsHaveChanged = componentsHaveChanged || componentHasChanged;
        if (componentHasChanged) {
          _this.formComponents[key] = newComponent;
        }
      });
      if (componentsHaveChanged) {
        _this.setState({
          form: _utils.FormUtils.getInitialFormState(_this.formComponents, nextProps.value)
        });
        return;
      }

      // Update state if Form property 'value' has changed
      var newFormState = _objectSpread({}, _this.state.form);
      var valueHasChanged = false;
      Object.keys(nextProps.value).forEach(function (key) {
        var newValue = nextProps.value[key];
        var fieldValueHasChanged = newFormState.meta[key] && newValue !== newFormState.meta[key].value;
        valueHasChanged = valueHasChanged || valueHasChanged;
        if (fieldValueHasChanged) {
          newFormState.meta[key] = _utils.FormUtils.getInitialFieldState(_this.formComponents[key], newValue, nextProps.value);
        }
      });
      if (valueHasChanged) {
        _this.setState({
          form: newFormState
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateFieldValidationState", function (component, validationResult) {
      var name = component.props.name;
      var newFormState = _objectSpread({}, _this.state.form);

      // Store timestamp for current async validations run
      _this.fieldValidationTimestamp[component.props.name] = validationResult.timestamp;

      // Update field state
      newFormState.meta[name].validationResult = validationResult;

      // Update Form calculated values by checking the values of its fields
      newFormState.isValid = _utils.FormUtils.getIsFormValid(newFormState.meta);
      newFormState.isPending = _utils.FormUtils.getIsFormPending(newFormState.meta);
      _this.setState({
        form: newFormState
      });
      return validationResult;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateFieldAsyncValidationState", function (component, validationResult) {
      // Do not update state if there is a newer validation running
      if (validationResult.timestamp && _this.fieldValidationTimestamp[component.props.name] > validationResult.timestamp) {
        return validationResult;
      }
      return _this.updateFieldValidationState(component, validationResult);
    });
    /* Handlers */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleFieldFocus", function (component) {
      var name = component.props.name;

      // Set initial field state
      var newFormState = _objectSpread({}, _this.state.form);
      newFormState.meta[name].previousValue = newFormState.meta[name].value;
      newFormState.meta[name].isFocused = true;
      return Promise.resolve(_this.setState({
        form: newFormState
      })).then(_this.notifyFocus(component));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleFieldBlur", function (component) {
      var _component$props = component.props,
        name = _component$props.name,
        validateOn = _component$props.validateOn;

      // Set initial field state
      var newFormState = _objectSpread({}, _this.state.form);
      var newValue = newFormState.meta[name].value;
      var valueHasChanged = newFormState.meta[name].previousValue !== newValue;
      if (valueHasChanged && validateOn !== 'change') {
        var fieldValues = _utils.FormUtils.getFieldsValues(newFormState.meta);
        return Promise.resolve(_utils.FormValidator.syncValidate(component, newValue, fieldValues)).then(function (result) {
          return _this.updateFieldValidationState(component, result);
        }).then(function (result) {
          return _utils.FormValidator.asyncValidate(component, newValue, fieldValues, result);
        }).then(function (result) {
          return _this.updateFieldAsyncValidationState(component, result);
        }).then(function () {
          return _this.notifyChange(component);
        }).then(_this.notifyBlur(component));
      }

      // Update field isFocused value and then set the new form state
      newFormState.meta[name].isFocused = false;
      return Promise.resolve(_this.setState({
        form: newFormState
      })).then(_this.notifyBlur(component));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleFieldChange", function (component, args) {
      var _component$props2 = component.props,
        name = _component$props2.name,
        validateOn = _component$props2.validateOn;
      var newValue = args.value;

      // Update field state
      var newFormState = _objectSpread({}, _this.state.form);
      newFormState.meta[name].value = newValue;
      newFormState.meta[name].isDirty = newFormState.meta[name].isDirty || newFormState.meta[name].previousValue !== newValue;
      if (validateOn === 'change') {
        var fieldValues = _utils.FormUtils.getFieldsValues(_this.state.form.meta);
        return Promise.resolve(_utils.FormValidator.syncValidate(component, newValue, fieldValues)).then(function (result) {
          return _this.updateFieldValidationState(component, result);
        }).then(function (result) {
          return _utils.FormValidator.asyncValidate(component, newValue, fieldValues, result);
        }).then(function (result) {
          return _this.updateFieldAsyncValidationState(component, result);
        }).then(function () {
          return _this.notifyChange(component);
        });
      }
      _this.setState({
        form: newFormState
      });
      return Promise.resolve(_this.notifyChange(component));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "notifyChange", function (component) {
      var fieldValues = _utils.FormUtils.getFieldsValues(_this.state.form.meta);
      _this.props.onChange({
        value: fieldValues,
        formState: _this.state.form,
        target: component.props.name
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "notifyFocus", function (component) {
      if (component.props.onFocus) {
        component.props.onFocus();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "notifyBlur", function (component) {
      if (component.props.onBlur) {
        component.props.onBlur();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleFormSubmit", function (e, action) {
      e.preventDefault();

      // Run validations for all non-validated fields but also for the the active element
      // in case the validation was triggered in a field after pressing ENTER.
      // Then, decide whether to submit the form or not based on the result.
      var activeElementName = document.activeElement && document.activeElement.name;
      var formMetadata = _this.state.form.meta;
      var componentKeysToValidate = Object.keys(formMetadata).filter(function (key) {
        return formMetadata[key].validationResult.isValid === undefined || key === activeElementName;
      });
      var fieldValues = _utils.FormUtils.getFieldsValues(formMetadata);
      var validationPromises = [];
      componentKeysToValidate.forEach(function (componentKey) {
        // Mark component as dirty as we are manipulating it
        // and we need to display information or error messages
        formMetadata[componentKey].isDirty = true;

        // Run validations on the component
        var component = _this.formComponents[componentKey];
        var validationPromise = Promise.resolve(_utils.FormValidator.syncValidate(component, fieldValues[componentKey], fieldValues)).then(function (result) {
          return _this.updateFieldValidationState(component, result);
        }).then(function (result) {
          return _utils.FormValidator.asyncValidate(component, component.value, fieldValues, result);
        }).then(function (result) {
          return _this.updateFieldAsyncValidationState(component, result);
        });
        validationPromises.push(validationPromise);
      });

      // Submit the form only if all sync & async validations
      // have passed and, at the end, the form is valid
      return Promise.all(validationPromises).then(function () {
        if (_this.state.form.isValid) {
          var submitAction = action || _this.props.onSubmit;
          submitAction({
            value: _this.state.form
          });
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "buildErrorSummaryFromMetadata", function () {
      var formMetadata = _this.state.form.meta;
      return Object.keys(formMetadata).reduce(function (acum, fieldKey) {
        var fieldErrors = formMetadata[fieldKey].validationResult.errors;
        var errorKeys = Object.keys(fieldErrors);
        if (!errorKeys.length) {
          return acum;
        }
        var message = errorKeys.map(function (errorKey) {
          return "".concat(fieldKey, ": ").concat(formMetadata[fieldKey].validationResult.errors[errorKey]);
        }).join('. ');
        acum.push(message);
        return acum;
      }, []).join('. ');
    });
    /* Rendering functions */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderErrorSummary", function () {
      var _this$props = _this.props,
        theme = _this$props.theme,
        testId = _this$props.testId;
      var errorSummary = _this.buildErrorSummaryFromMetadata();
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-test-id": testId && "".concat(testId, "-error-summary"),
        "aria-live": "assertive",
        "aria-atomic": true,
        className: theme['visually-hidden']
      }, errorSummary ? "Errors found: ".concat(errorSummary, ".") : null);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderChildren", function (component) {
      if (!component || !component.props) {
        return component;
      }
      if (component.type && component.type.isFormComponent) {
        return _this.renderFormComponent(component);
      }
      if (component.props.type === 'submit') {
        return _this.renderSubmitButton(component);
      }
      return /*#__PURE__*/_react["default"].cloneElement(component, {
        children: _react["default"].Children.map(component.props.children, _this.renderChildren)
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderFormComponent", function (component) {
      var _component$props3 = component.props,
        id = _component$props3.id,
        name = _component$props3.name,
        label = _component$props3.label,
        required = _component$props3.required;
      var fieldMeta = _this.state.form.meta[name];
      var _fieldMeta$validation = fieldMeta.validationResult,
        isValid = _fieldMeta$validation.isValid,
        errors = _fieldMeta$validation.errors,
        pendingValidations = _fieldMeta$validation.pendingValidations;
      var needsLabel = !componentsNotNeedingLabels.includes(component.type.displayName);
      var childProps = _objectSpread(_objectSpread({}, fieldMeta), {}, {
        isValid: isValid,
        'isPending': pendingValidations && Object.keys(pendingValidations).length > 0,
        id: id,
        name: name,
        'onFocus': function onFocus() {
          return _this.handleFieldFocus(component);
        },
        'onBlur': function onBlur() {
          return _this.handleFieldBlur(component);
        },
        // These two values convert the component to a controlled component
        // See https://fb.me/react-controlled-components
        'onChange': function onChange(args) {
          return _this.handleFieldChange(component, args);
        },
        'value': fieldMeta.value !== undefined && fieldMeta.value !== null ? fieldMeta.value : '',
        'aria-invalid': isValid === false && fieldMeta.isDirty
      });

      // Remove internal props from child props
      delete childProps.validationResult;
      delete childProps.previousValue;
      return /*#__PURE__*/_react["default"].createElement(_FormComponent["default"], {
        name: name,
        label: needsLabel ? label : null,
        required: required,
        errors: errors,
        childProps: childProps,
        theme: _this.props.theme.FormComponent
      }, component);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderSubmitButton", function (component) {
      // Use component props if they are defined. Otherwise, use formState
      var _component$props4 = component.props,
        disabled = _component$props4.disabled,
        isLoading = _component$props4.isLoading;
      var isButtonLoading = isLoading || _this.state.form.isValid && _this.state.form.isPending;
      return /*#__PURE__*/_react["default"].cloneElement(component, {
        disabled: disabled,
        isLoading: isButtonLoading,
        onClick: function onClick(evt) {
          return _this.handleFormSubmit(evt, component.props.action);
        }
      });
    });
    _this.fieldValidationTimestamp = {};
    _this.formComponents = _utils.FormUtils.getFormComponents(props.children);
    _this.state = {
      form: _utils.FormUtils.getInitialFormState(_this.formComponents, props.value)
    };
    return _this;
  }
  (0, _createClass2["default"])(Form, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        className = _this$props2.className,
        theme = _this$props2.theme,
        testId = _this$props2.testId,
        children = _this$props2.children,
        onChange = _this$props2.onChange,
        onSubmit = _this$props2.onSubmit,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      return /*#__PURE__*/_react["default"].createElement("form", (0, _extends2["default"])({
        className: (0, _classnames["default"])(className, theme.form),
        "data-test-id": testId,
        "data-anypoint-component": "Form",
        onSubmit: this.handleFormSubmit
      }, props), this.renderErrorSummary(), _react["default"].Children.map(children, this.renderChildren));
    }
  }]);
  return Form;
}(_react["default"].PureComponent);
(0, _defineProperty2["default"])(Form, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Form, "displayName", 'Form');
//# sourceMappingURL=Form.js.map